import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import CMSText from '../Global/CMSText'
import ProductPriceFormat from './ProductPriceFormat'
import BuyAbleMention from './BuyAbleMention'
import { LayoutStyle } from '@/typings/base'
import { makeStyles, createStyles, Typography, Theme } from '@material-ui/core'

const useStyles = makeStyles<Theme, LayoutStyle>((theme: Theme) =>
  createStyles({
    price: {
      fontWeight: 700,
      marginTop: theme.spacing(1),
    },
    priceSecondHand: {
      marginTop: 0,
    },
  })
)

interface ProductCardPriceProps {
  priceMin: number
  isDisplayedPrice: boolean | null
  secondHandAvailability: boolean
  isSecondHand: boolean
  takeback: any
  promotions: any
  productIsSecondHand: boolean
  availability: boolean
  isSecondHandTaxon: boolean
  settings: any
  isBuyableProduct: boolean
  discountPriceFormat: string
  _type?: 'ttc' | 'ht'
  hideLabel?: boolean
  productTaxons?: { main: string; others?: string[] | null }
}

const ProductCardPrice = ({
  priceMin,
  isDisplayedPrice,
  secondHandAvailability,
  isSecondHand,
  takeback,
  promotions,
  productIsSecondHand,
  availability,
  isSecondHandTaxon,
  settings,
  isBuyableProduct,
  discountPriceFormat,
  _type,
  hideLabel = false,
  productTaxons,
}: ProductCardPriceProps) => {
  const layoutStyle = {
    isDisplayedPrice: isDisplayedPrice || isDisplayedPrice === null,
  }
  const classes = useStyles(layoutStyle)
  const { t } = useTranslation()

  const afterCurrency = _type
    ? ' ' +
      (_type === 'ht'
        ? t('texts:general:vat:excluded')
        : t('texts:general:vat:included'))
    : null

  if (
    priceMin === 0 ||
    (isDisplayedPrice !== true && isDisplayedPrice !== null)
  ) {
    return null
  }

  return (
    <>
      {!hideLabel && secondHandAvailability && isSecondHand && (
        <span className="productCard__price_start">
          <CMSText
            asText
            data={takeback?.data?.price_start}
            defaultText={t('texts:takeBack:price_start')}
          />
        </span>
      )}
      <Typography
        noWrap
        variant="body2"
        color={'secondary'}
        className={clsx(
          'productCard__price',
          classes.price,
          secondHandAvailability &&
            isSecondHand && [
              classes.priceSecondHand,
              'productCard__price--second-hand',
            ],
          _type === 'ttc' && 'productCard__price--ttc'
        )}
      >
        <ProductPriceFormat
          promotions={promotions}
          isSecondHand={!!productIsSecondHand}
          avalableForRentalAndSecondHand={
            availability && secondHandAvailability
          }
          isDisplayPercentage
          isSecondHandTaxon={isSecondHandTaxon}
          priceMin={priceMin}
          settings={settings}
          isBuyableProduct={isBuyableProduct}
          discountPriceFormat={discountPriceFormat}
          classe={'productCard'}
          afterCurrency={afterCurrency}
          productTaxons={productTaxons}
        />
        {isBuyableProduct && (
          <BuyAbleMention
            buyAbleMention={settings?.display_buyable_mention as any}
          />
        )}
      </Typography>
    </>
  )
}

export default ProductCardPrice
